export const baseUrl = "https://api.roshan-shop.ir";

// export const baseUrl = "http://192.168.10.25:8000";
